<template>
  <div>
    <div class="header-term">
      <div class="header-wrapper">
        <div class="header-logo">
          <img src="@/assets/img/ico_logo_zengo.svg"/>
        </div>
      </div>
    </div>
    <div class="main-term">
      <router-view></router-view>
      <div class="footer">
        <div class="copyright">{{ $t('common.footer.copyright') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CopyrightLayout'
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/CopyrightLayout.vue